module.exports = [{"type":"hash","text":"Heartbeats"},{"type":"normal","text":"Once the Websocket Client and Websocket Server get connected, the server will send a heartbeat- ping message every 5 seconds (the frequency might change)."},{"type":"code","text":"{\"ping\":\"2177c68e4d0e45679965f482929b59c2\",\"time\":\"2022-06-07T16:27:36.323+0800\"}"},{"type":"normal","text":"When the Websocket Client receives this heartbeat message, it should return pong message."},{"type":"code","text":"pong"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce/04_heart_beat.json
// module id = Ze9p
// module chunks = 3